/**
 * Mood level enumeration — 5-point mood scale
 */
export var MoodLevel;
(function (MoodLevel) {
    MoodLevel["AWFUL"] = "AWFUL";
    MoodLevel["BAD"] = "BAD";
    MoodLevel["OKAY"] = "OKAY";
    MoodLevel["GOOD"] = "GOOD";
    MoodLevel["GREAT"] = "GREAT";
})(MoodLevel || (MoodLevel = {}));
